import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React, { useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCareer } from "../careerSlice";
import Navbar from "../components/Navbar";
import reducer from "../reducer";

const RecruitRow = ({ id, title, publishTime }) => (
  <>
    <div className="card border-0 user-radius mt-3 shadow">
      <div className="card-body">
        <div className="row">
          <div className="col">
            <a href={`#/招聘会/${id}`} style={{ color: "#202529", textDecoration: "none" }}>
              <div className="pull-left">
                <strong>{title}</strong>
              </div>
              <div className="pull-right">
                <span style={{ color: "#007dff" }}>
                  详情
                  <FontAwesomeIcon icon={faChevronCircleRight} size="lg" fixedWidth />
                </span>
              </div>
              <br />
              <span className="text-muted">
                截止时间:
                {dayjs(publishTime).format("YYYY-MM-DD HH:mm")}
              </span>
              <br />
            </a>
          </div>
        </div>
      </div>
    </div>
  </>
);

RecruitRow.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  publishTime: PropTypes.string.isRequired,
};

const List = () => {
  // const [list, setList] = useState([]);
  const [state, dispatch] = useReducer(reducer, {
    CAREER: useSelector((state) => state.career.list),
  });
  const reduxDispatch = useDispatch();

  useEffect(() => {
    document.title = "招聘会";
    if (0 === state.CAREER.length) {
      const url = [
        "/api/simple/bulletin",
        "?option=filterBy-tag-detail",
        '&tag=["线上招聘会"]',
        '&detail={"status":"启用"}',
        "&take=60",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          if (data.length) {
            data.reverse();
            dispatch({
              type: "set",
              payload: { key: "CAREER", value: data },
            });
            reduxDispatch(setCareer({ list: data }));
          }
        });
    }
  }, []);

  return (
    <>
      <div className="container-fluid">
        {state.CAREER.length === 0 ? (
          <div className="chat-login">
            <h6>近期还没有线上招聘会</h6>
          </div>
        ) : (
          <div>
            {state.CAREER &&
              state.CAREER.map((item) => (
                <RecruitRow
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  publishTime={item.expire_at}
                />
              ))}
          </div>
        )}
      </div>
      <Navbar category="校园招聘" />
    </>
  );
};

export default List;
